import { render, staticRenderFns } from "./my-projectUpload.vue?vue&type=template&id=20c24cfc&scoped=true&"
import script from "./my-projectUpload.vue?vue&type=script&lang=js&"
export * from "./my-projectUpload.vue?vue&type=script&lang=js&"
import style0 from "./my-projectUpload.vue?vue&type=style&index=0&id=20c24cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c24cfc",
  null
  
)

export default component.exports